module.exports = __webpack_public_path__ + "static/logo-cbfbad1d41050484bfc55b5143d7b623.png";